import { render, staticRenderFns } from "./status-icon.vue?vue&type=template&id=34e06900&scoped=true&"
import script from "./status-icon.vue?vue&type=script&lang=js&"
export * from "./status-icon.vue?vue&type=script&lang=js&"
import style0 from "./status-icon.vue?vue&type=style&index=0&id=34e06900&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e06900",
  null
  
)

export default component.exports